import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Button, Heading, HStack, Spinner } from "@chakra-ui/react";
import GenericForm from "components/BuilderForm/GenericForm";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useApi from "hooks/useApi";
import toast from "react-hot-toast";
import { createFeature, createPlan, getFormData, getSingleFeatureData } from "../plans/apiService";
import { useQueryParams } from "utils/common";

const CreateFeature = () => {
  const initialFormData = {
    value_template: "",
    key: "",
    label: "",
    description: "",
  }
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const { apiCall, loading } = useApi();
  const {propertyId:featureId} = useQueryParams();
  const history = useHistory();

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = ({ updatedFormData }) => {
    const newErrors = {};

    Object.keys(updatedFormData).forEach((field) => {
      if (!updatedFormData[field]) {
        newErrors[field] = `${field} is required.`;
      }
    });

    return { newErrors, payload: updatedFormData };
  };

  const getFormDataFn = async (featureId) => {
    try {
      const response = await getSingleFeatureData({ apiCall, featureId });
      setFormData({ ...response?.feature });
    } catch (error) {
      console.log("Error fetching property data", error);
    }
  };

  useEffect(() => {
    if (featureId) {
      getFormDataFn(featureId);
    }
  }, [featureId]);

  const handleFormSubmit = async () => {
    try {
      const { newErrors, payload } = validateForm({
        updatedFormData: formData,
      });

      const payloadData = {
        features: [payload],
      };

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        toast.error("Please correct the errors in the form.");
        return;
      }

      const response = await createFeature({ apiCall, payload:payloadData });
      if (response) {
        if (!featureId) {
          setFormData(initialFormData);
          history.push("/admin/feature-list");
          return;
        } else {  
          if (response) {
            toast.success("Features Updated successfully!");
          }
          return;
        }
      }
    } catch (error) {
      console.error("Error submitting plan:", error);
      toast.error(
        error.message || "An error occurred while submitting the plan."
      );
    }
  };

  return (
    <Box
      p={4}
      px={{ base: 4, md: 8 }}
      maxW={{ base: "100%", md: "992px" }}
      mx="auto"
    >
      <Box onClick={() => history.goBack()} style={{ cursor: "pointer" }}>
        <ArrowBackIcon />
      </Box>
      {loading && <Spinner size="lg" />}
      <Box textAlign="center" mb={6}>
        <Heading>{featureId ? "Update Feature" : "Create Feature"}</Heading>
      </Box>
      <GenericForm
        formType="feature"
        formData={formData}
        onChange={handleFormChange}
        errors={errors}
        setErrors={setErrors}
      />
      <HStack mt={4} justifyContent="center" alignItems="center" spacing={4}>
        <Button
          colorScheme="teal"
          size="lg"
          px={8}
          py={6}
          fontSize="lg"
          bg="purple.500"
          borderRadius="5px"
          borderColor="#637381"
          background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
          color="#ffffff"
          onClick={handleFormSubmit}
          disabled={loading}
        >
          Submit
        </Button>
      </HStack>
    </Box>
  );
};

export default CreateFeature;
